<template>
  <v-alert rounded outlined light color="deep-purple" class="pa-1 py-3">
    <v-card-title class="ma-0 py-2 pl-1">
      <h6 class="deep-purple--text lighten-2 font-weight-semibold">
        Textos diagnóstico
      </h6>
    </v-card-title>

    <v-card-text class="pb-0">
      <div v-if="loading" class="d-flex justify-center py-2">
        <v-progress-circular indeterminate color="deep-purple" size="24" />
      </div>

      <v-row
        v-else-if="errorMessage"
        align="center"
        justify="space-between"
        class="w-100"
      >
        <span class="black--text font-weight-light">{{ errorMessage }}</span>
        <v-icon color="red lighten-1" size="24">mdi-alert-circle-outline</v-icon>
      </v-row>

      <v-row
        v-else-if="!hasPending"
        align="center"
        justify="space-between"
        class="w-100"
      >
        <span class="black--text font-weight-light">Sin textos pendientes</span>
        <v-icon color="green lighten-1" size="24">mdi-check-circle-outline</v-icon>
      </v-row>

      <div v-else>
        <v-row align="center" class="w-100 mb-1">
          <v-icon color="orange lighten-1" size="24">mdi-alert-circle-outline</v-icon>
          <span class="black--text font-weight-light ml-1">
            {{ pendingItems.length }} texto(s) pendiente(s):
          </span>
        </v-row>
        <div
          v-for="(item, i) in pendingItems"
          :key="i"
          class="pl-2 py-1"
        >
          <span class="black--text font-weight-light">• {{ item.diagnostic.name }}</span>
          <v-chip x-small class="ml-1" :color="levelColor(item.diagnostic.diagnosticLevel)" dark>
            {{ levelLabel(item.diagnostic.diagnosticLevel) }}
          </v-chip>
        </div>
      </div>
    </v-card-text>
  </v-alert>
</template>

<script>
import diagnosticService from '@/services/diagnostic.service';

export default {
  name: 'StudentPendingDiagnostics',
  props: {
    studentId: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    loading: false,
    pendingItems: [],
    errorMessage: '',
  }),
  computed: {
    hasPending() {
      return this.pendingItems.length > 0;
    },
  },
  methods: {
    levelLabel(level) {
      const labels = {
        INITIAL: 'Inicial',
        INTERMEDIATE: 'Intermedia',
        ADVANCED: 'Final',
      };
      return labels[level] ?? level;
    },
    levelColor(level) {
      const colors = {
        INITIAL: 'blue darken-1',
        INTERMEDIATE: 'orange darken-1',
        ADVANCED: 'green darken-1',
      };
      return colors[level] ?? 'grey';
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const response = await diagnosticService.findDiagnosticoPendiente(this.studentId);
      const { status, content } = response?.data ?? {};

      // Backend may return HTTP 200 with an internal error status.
      // Some endpoints use code 0 for success, others use code 1 with name 'OK'.
      const isSuccess = status?.code === 0 || status?.code === 1 || status?.name === 'OK';
      if (status?.code !== undefined && !isSuccess) {
        this.errorMessage = typeof content === 'string' ? content : 'Error al obtener diagnósticos pendientes.';
        this.pendingItems = [];
      } else {
        this.pendingItems = Array.isArray(content) ? content : [];
      }
    } catch (e) {
      console.error('[BEE-448] Error al obtener diagnósticos pendientes:', e);
      this.errorMessage = 'Error al obtener diagnósticos pendientes.';
      this.pendingItems = [];
    } finally {
      this.loading = false;
    }
  },
};
</script>
